<template>
    <el-dialog title="查看示例" class="exampleDialog" width="415px" :visible.sync="dialogVisible">
        <div class="content">
            <img :src="certtype === 1 ? example1 : example2" />
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="download">下载原图</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { format } from 'path'
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            dialogVisible: false,
            example1: require('../../../../../public/img/example_1.png'),
            example2: require('../../../../../public/img/example_2.png'),
            certtype: '',
        }
    },
    created() {
        console.log(this.publicPath)
    },
    methods: {
        open(certtype) {
            this.certtype = certtype
            this.dialogVisible = true
        },
        download() {
            console.log(this.publicPath)
            var link = document.createElement('a')
            if (this.certtype === 1) {
                link.href = `${this.publicPath}img/example_1.png`
                link.download = 'example_1.png'
            } else {
                link.href = `${this.publicPath}img/example_2.png`
                link.download = 'example_2.png'
            }
            // link.href = `http://img.jingketong.cn/download/dis_eccode_template.xlsx`
            link.click() // 释放内存
            window.URL.revokeObjectURL(link.href)
        }
    },
    computed: {
        
    }
}
</script>
<style lang="scss">
    .exampleDialog {
        .el-dialog__body {
            padding-bottom: 0;
        }
        .content {
            img {
                width: 375px;
                height: 666px;
            }
        }
        .dialog-footer {
            .el-button {
                margin: 0;
            }
        }
    }
</style>